<template>
  <div class="sidebar" :data="backgroundColor">
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <div class="logo">
        <a href="/" class="simple-text logo-mini">
          <img :src="logo" alt="app-logo" />
        </a>
        <a href="/" class="simple-text logo-normal logoTxt-img">
           <img :src="title" alt="app-logo-txt" />           
        </a>
        <!--a href="/" class="simple-text logo-normal">
          {{ title }}
        </-a-->
      </div>
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
            @click.native="getlearnReactorParents(link)"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
              @click.native="getlearnReactorChildren(subLink)"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
// import {eventEmitter} from "src/plugins/globalComponents.js";
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'img/icon-vue.png',
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      default: 'CT',
      description: 'Sidebar short title'
    },
    logo: {
      type: String,
      default: 'img/icon-vue.png',
      description: 'Sidebar app logo'
    },
    backgroundColor: {
      type: String,
      default: 'vue',
      validator: value => {
        let acceptedValues = [
          '',
          'vue',
          'blue',
          'green',
          'orange',
          'red',
          'primary'
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        'Sidebar background color (vue|blue|green|orange|red|primary)'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  data() {
		return {
			videoParents: 'none',
			videoChildren: 'none',
		};
	},
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    getlearnReactorParents(link){
      this.videoParents = 'none'; 
      this.videoChildren = 'none';

      if(link.videoUrl && link.videoUrl !='none'){
        this.videoParents = link.videoUrl;
        this.$emit('videoParents', this.videoParents);
        // eventEmitter.$emit('videoObject', this.videoParents);
      } else { 
        this.videoParents = 'none'; this.$emit('videoParents', this.videoParents);
      }
      sessionStorage.removeItem("lead-search-objects");
      sessionStorage.removeItem("lead-objects-open");
      // console.log('this.videoParents', this.videoParents);

		},
    getlearnReactorChildren(link){
      this.videoParents = 'none'; 
      this.videoChildren = 'none'; 

      if(link.videoUrl && link.videoUrl !='none'){
        this.videoChildren = link.videoUrl;
        this.$emit('videoChildren', this.videoChildren);
        // eventEmitter.$emit('videoObject', this.videoChildren);
      } else { 
        this.videoChildren = 'none'; this.$emit('videoChildren', this.videoChildren);
      }
      sessionStorage.removeItem("lead-search-objects");
      sessionStorage.removeItem("lead-objects-open");
		},
    
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
